import { Navigate, useLocation } from 'react-router-dom';
import { useOnboardingWizardControl } from './OnboardingWizardProvider';

/**
 * Keeps mandatory onboarding (first-time or reassigned assignee) on `/`.
 * Voluntary reopen from the Courses banner is not locked — see OnboardingWizardProvider.
 */
export function OnboardingRootRouteGuard() {
  const location = useLocation();
  const { requiresRootOnboardingRoute } = useOnboardingWizardControl();

  if (requiresRootOnboardingRoute && location.pathname !== '/') {
    return <Navigate to="/" replace />;
  }

  return null;
}
